import NftLinkPopup from './NftLinkPopup';
import NftLinkPopupContainer from './NftLinkPopup.container';
export default NftLinkPopupContainer(NftLinkPopup);
